export default{
    datosphp:[],
    act:null,
    fields:'',
    error:null,
    errorMessage:'',
    totalRow:null,
    
    
}